const ProfilePage = () => {
    return (
        <div>
            Orders Page
        </div>
    )
}

export default ProfilePage;